import React from 'react'
import styled from 'styled-components'

import { colors } from '../../styles/variables'
import { media } from '../../styles/util'

const Container = styled('div')<{ hideMobile?: boolean }>`
  padding-left: 6px;
  margin-top: 10px;
  padding-bottom: 40px;

  ${media.tablet`
    display: ${props => (props.hideMobile ? 'none' : 'inline')};
  `}
`

const MobileSocialMedia = styled.div`
  display: inline-block;
  height: 33px;
  margin: 12px 30px 0 0;
  transition: 200ms transform ease-in-out;

  &:hover {
    transform: scale(1.07);

    & svg > path {
      fill: ${colors.orange};
    }
  }

  & svg > path {
    transition: 200ms fill ease-in-out;
    fill: ${colors.lightText};
  }
`

const MenuSocial = ({ isFooter = false }: { isFooter?: boolean }) => (
  <Container hideMobile={isFooter}>
    <div>
      <a href="https://www.instagram.com/petfinn/" target="_blank" rel="noopener noreferrer" aria-label="Instagram page">
        <MobileSocialMedia>
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M27 8.7999C27 9.8999 27.1 11.7999 27.1 14.3999C27.1 16.9999 27.1 18.8999 27 19.9999C26.9 21.0999 26.8 22.0999 26.5 22.9999C26.1 23.9999 25.6 24.8999 24.8 25.5999C24.1 26.2999 23.2 26.8999 22.2 27.2999C21.4 27.5999 20.4 27.7999 19.2 27.7999C18 27.9999 16.1 27.9999 13.5 27.9999C10.9 27.9999 9 27.9999 7.9 27.8999C6.8 27.7999 5.8 27.5999 4.9 27.2999C3.9 26.9999 3 26.3999 2.3 25.6999C1.5 24.9999 1 24.0999 0.6 23.0999C0.3 22.2999 0.1 21.2999 0.1 20.0999C0 18.9999 0 17.0999 0 14.4999C0 11.8999 0 9.9999 0.1 8.7999C0.2 7.6999 0.3 6.6999 0.6 5.7999C1 4.7999 1.5 3.8999 2.3 3.1999C3 2.4999 3.9 1.8999 4.9 1.4999C5.7 1.1999 6.7 0.999902 7.9 0.999902C9 0.899902 10.9 0.899902 13.5 0.899902C16.1 0.899902 18 0.999902 19.2 0.999902C20.3 1.0999 21.3 1.1999 22.2 1.4999C23.2 1.8999 24.1 2.3999 24.8 3.1999C25.5 3.8999 26.1 4.7999 26.5 5.7999C26.7 6.6999 26.9 7.6999 27 8.7999ZM24.1 22.3999C24.3 21.6999 24.5 20.5999 24.6 19.0999C24.6 18.1999 24.7 16.9999 24.7 15.3999V13.4999C24.7 11.7999 24.7 10.5999 24.6 9.7999C24.5 8.2999 24.4 7.1999 24.1 6.4999C23.6 5.2999 22.8 4.3999 21.5 3.8999C20.9 3.6999 19.8 3.4999 18.2 3.3999C17.3 3.3999 16.1 3.2999 14.5 3.2999H12.6C11 3.2999 9.7 3.2999 8.9 3.3999C7.3 3.4999 6.2 3.5999 5.6 3.8999C4.3 4.3999 3.4 5.1999 3 6.4999C2.8 7.0999 2.6 8.1999 2.5 9.7999C2.5 10.6999 2.4 11.8999 2.4 13.4999V15.3999C2.4 16.9999 2.4 18.2999 2.5 19.0999C2.6 20.5999 2.7 21.6999 3 22.3999C3.5 23.5999 4.4 24.4999 5.6 24.9999C6.3 25.1999 7.4 25.3999 8.9 25.4999C9.8 25.4999 11 25.5999 12.6 25.5999H14.5C16.2 25.5999 17.4 25.5999 18.2 25.4999C19.7 25.3999 20.8 25.2999 21.5 24.9999C22.7 24.4999 23.6 23.5999 24.1 22.3999ZM13.5 7.4999C14.7 7.4999 15.9 7.7999 17 8.3999C18.1 8.9999 18.9 9.8999 19.5 10.8999C20.1 11.9999 20.4 13.0999 20.4 14.3999C20.4 15.6999 20.1 16.7999 19.5 17.8999C18.9 18.9999 18 19.7999 17 20.3999C15.9 20.9999 14.8 21.2999 13.5 21.2999C12.2 21.2999 11.1 20.9999 10 20.3999C9 19.7999 8.1 18.9999 7.5 17.8999C6.9 16.7999 6.6 15.6999 6.6 14.3999C6.6 13.0999 6.9 11.9999 7.5 10.8999C8.1 9.7999 9 8.9999 10 8.3999C11.1 7.7999 12.3 7.4999 13.5 7.4999ZM13.5 18.9999C14.7 18.9999 15.8 18.5999 16.7 17.6999C17.6 16.7999 18 15.6999 18 14.4999C18 13.2999 17.6 12.1999 16.7 11.2999C15.8 10.3999 14.7 9.9999 13.5 9.9999C12.3 9.9999 11.2 10.3999 10.3 11.2999C9.4 12.1999 9 13.2999 9 14.4999C9 15.6999 9.4 16.7999 10.3 17.6999C11.2 18.4999 12.3 18.9999 13.5 18.9999ZM22.4 7.1999C22.4 6.7999 22.2 6.3999 21.9 6.0999C21.6 5.7999 21.2 5.5999 20.8 5.5999C20.4 5.5999 20 5.7999 19.7 6.0999C19.4 6.3999 19.2 6.7999 19.2 7.1999C19.2 7.5999 19.4 7.9999 19.7 8.2999C20 8.5999 20.4 8.7999 20.8 8.7999C21.2 8.7999 21.6 8.5999 21.9 8.2999C22.2 7.9999 22.4 7.6999 22.4 7.1999Z" />
          </svg>
        </MobileSocialMedia>
      </a>
      {/* <ExternalLink to="https://www.facebook.com/petfinn/">
        <MobileSocialMedia>
          <svg width="17" height="31" viewBox="0 0 17 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.3002 17.1H0.700195V11.6H5.3002V7.2C5.3002 4.9 5.9002 3.1 7.2002 1.9C8.5002 0.6 10.2002 0 12.3002 0C14.0002 0 15.4002 0.1 16.5002 0.2V5.1H13.6002C12.5002 5.1 11.8002 5.3 11.4002 5.8C11.1002 6.2 10.9002 6.8 10.9002 7.7V11.5H16.0002L15.3002 17H11.0002V30.8H5.3002V17.1Z" />
          </svg>
        </MobileSocialMedia>
      </ExternalLink> */}
    </div>
  </Container>
)
export default React.memo(MenuSocial)
